import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player';
import Navbar from '../../../ReusableBlocks/Navbar';
import Footer from '../../../ReusableBlocks/FooterBlock';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';
import { generiSearch } from '../../../Redux/Dashboard/External/Search/GenericSearchAction';
import { fetchLearningHub } from '../../../Redux/Dashboard/External/LearningHub/LearningHubGetDataAction';
import Swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import * as PATH from '../../../CentralisedLink'
import { useSnackbar } from 'notistack';
import { getContentStoreCardBackgroundStyle, getMediaProvider, normalizeMediaUrl } from '../../../Utils/mediaUrls';

// Loading Spinner Component
const LoadingSpinner = () => (
    <div className="spinner">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
    </div>
);

const isVideoContent = (file) => ['Video', 'Demo Shorts', 'Shorts'].includes(file?.contentType);

const formatReleaseDate = (dateValue) => {
    if (!dateValue) {
        return '';
    }
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) {
        return String(dateValue);
    }
    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
};




const Search_Result = (props) => {

    const { enqueueSnackbar } = useSnackbar();

    const narrativeSecretKey = 'narrative';
    const microcertSecretKey = 'micro';

    const encryptId = (id, type) => {

        console.log("Id" + id)
        console.log("Type" + type)

        if (type === 'narrative') {
            console.log("It is Narrative")
            const ciphertext = CryptoJS.AES.encrypt(id, narrativeSecretKey).toString();
            return encodeURIComponent(ciphertext);
        } else if (type === 'microcert') {
            console.log("It is Microcert")
            const ciphertext = CryptoJS.AES.encrypt(id, microcertSecretKey).toString();
            return encodeURIComponent(ciphertext);

        } else {
            alert("Something Goes wrong")
        }

    };



    const [searchParams] = useSearchParams();
    const query = searchParams.get('query');
    const dispatch = useDispatch();

    const { results, loading, error } = useSelector(state => state.GernicSearch);
    const searchResults = results.result;
    console.log(results.result)

    const [sortedResults, setSortedResults] = useState([]);
    const [expandedIndex, setExpandedIndex] = useState(null);

    // Content useState
    const [showFileModal, setFileModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const [playing, setPlaying] = useState(false);


    // Playbook useState
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPlaybookModalOpen, setIsPlaybookModalOpen] = useState(false);
    const [selectedPlaybooks, setSelectedPlaybooks] = useState([]);
    const [selectedPlaybook, setSelectedPlaybook] = useState(null)








    useEffect(() => {
        if (query) {
            dispatch(generiSearch(query));
        }
    }, [query, dispatch]);

    useEffect(() => {
        dispatch(fetchLearningHub());
    }, [dispatch]);

    // Search Error
    useEffect(() => {
        if (error) {
            Swal.fire({
                title: 'Error',
                text: error,
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: 'Try to refresh page',
                customClass: {
                    title: 'my-custom-title-of-pop-login',
                    confirmButton: 'my-custom-button-of-pop',
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        }
    }, [error]);

    useEffect(() => {
        setSortedResults(results.result);
    }, [results]);


    useEffect(() => {
        // Reset playing state when URL changes
        if (isVideoContent(selectedFile)) {
            setPlaying(false);
        }
    }, [selectedFile?.viewUrl]);


    const handleSortChange = (e) => {
        const sortBy = e.target.value;
        let sortedData = [...results.result];

        switch (sortBy) {
            case 'narrative':
                sortedData = sortedData.filter(item => item.type === 'narrative');
                break;
            case 'content':
                sortedData = sortedData.filter(item => item.type === 'content');
                break;
            case 'microcert':
                sortedData = sortedData.filter(item => item.type === 'microcert');
                break;
            case 'faq':
                sortedData = sortedData.filter(item => item.type === 'faq');
                break;
            default:
                sortedData = results.result;
                break;
        }

        setSortedResults(sortedData);
    };





    // Content Showing Functions
    const handlePlayButtonClick = () => {
        setPlaying(true);
    };


    const handleShowFileModal = (file) => {
        let modifiedViewUrl = normalizeMediaUrl(file.viewUrl, 'preview');
        if (getMediaProvider(file.viewUrl) !== 'google-drive' && isVideoContent(file)) {
            // Change 'view' to 'preview' for mp4 files
            modifiedViewUrl = modifiedViewUrl.replace('/view', '/preview');
        } else if (getMediaProvider(file.viewUrl) !== 'google-drive' && file.contentType === 'Presentation') {
            // Append "&rm=minimal" to the viewUrl for pptx files
            modifiedViewUrl += '&rm=minimal';
        }
        setSelectedFile({ ...file, viewUrl: modifiedViewUrl });
        setFileModal(true);
    };


    const handleCloseFileModal = () => {
        setSelectedFile(null);
        setFileModal(false);
    };


    const getVideoDownloadFileName = (file) => {
        const fileName = file.fileName || file.title || file.name || 'video';

        return /\.[a-z0-9]+$/i.test(fileName) ? fileName : `${fileName}.mp4`;
    };

    const downloadVideo = async (videoUrl, file) => {
        setDownloading(true);

        try {
            const response = await fetch(videoUrl, { mode: 'cors' });

            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = getVideoDownloadFileName(file);

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Failed to download video as blob. Falling back to opening the URL.', error);
            window.open(videoUrl, '_blank', 'noopener,noreferrer');
        } finally {
            setDownloading(false);
        }
    };

    const downloadFile = (file) => {
        console.log(file)
        let downloadUrl;

        // Check if the file is a video
        if (isVideoContent(file)) {
            const videoDownloadUrl = file.downloadUrl || file.viewUrl;
            const normalizedVideoDownloadUrl = normalizeMediaUrl(videoDownloadUrl, 'download');

            if (getMediaProvider(videoDownloadUrl) === 'google-drive') {
                window.open(normalizedVideoDownloadUrl, '_blank', 'noopener,noreferrer');
                return;
            }

            downloadVideo(normalizedVideoDownloadUrl, file);
            return;
        }

        // Set loading state
        setDownloading(true);

        downloadUrl = normalizeMediaUrl(file.downloadUrl, 'download');

        // Create a temporary anchor element to initiate the download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `${file.fileName}.${file.fileExtension}`;

        // Append the anchor to the document body and trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up by removing the anchor from the document body
        document.body.removeChild(link);

        // Clear loading state after initiating the download
        setDownloading(false);
    };


    const handleContextMenu = (event) => {
        event.preventDefault(); // Prevents the context menu from appearing
    };

    // ----------------XXXXX---------------




    // Playbook Showing FUnctions
    const handlePlaybookClick = (playbook) => {
        if (Array.isArray(playbook) && playbook.length > 1) {
            setSelectedPlaybooks(playbook);
            setIsModalOpen(true);
        } else if (Array.isArray(playbook) && playbook.length === 1) {
            setSelectedPlaybook(playbook[0]);
            setIsPlaybookModalOpen(true);
        } else if (playbook) {
            setSelectedPlaybook(playbook);
            setIsPlaybookModalOpen(true);
        }
    };

    const handlePlaybookSelection = (playbook) => {
        setSelectedPlaybook(playbook);
        setIsModalOpen(false);
        setIsPlaybookModalOpen(true);
    };


    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedPlaybook(null);
        setSelectedPlaybooks([]);
    };


    const closePlaybookModal = () => {
        setIsPlaybookModalOpen(false);
        setSelectedPlaybook(null);
    };


    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                enqueueSnackbar('Password copied to clipboard!', { variant: 'success' });
            })
            .catch(() => {
                enqueueSnackbar('Failed to copy Password.', { variant: 'error' });
            });
    };
    // -------------XX--------------






    const handleToggle = (index) => {
        if (expandedIndex === index) {
            setExpandedIndex(null); // Collapse the content if already expanded
        } else {
            setExpandedIndex(index); // Expand the content
        }
    };




    return (
        <>
            <Navbar />
            <div className='container'>
                {/* Header */}
                <div className='searc-top-filter-div'>
                    <p className='searc-result-query'>{searchResults?.length} results for “{query}”</p>
                    <div className='sort-dropdown'>
                        <select onChange={handleSortChange}>
                            <option value="all">All Types</option>
                            <option value="narrative">Narratives</option>
                            <option value="content">Content</option>
                            <option value="microcert">Microcerts</option>
                            <option value="faq">FAQs</option>
                        </select>
                    </div>
                </div>

                <br />

                {/* Display Results */}
                <div>
                    {loading && <LoadingSpinner />}
                    {error && <p>Error: {error}</p>}




                    {!loading && (
                        <>
                            {sortedResults?.length > 0 ? (
                                <>
                                    {/* Narratives */}
                                    {sortedResults?.filter(item => item.type === 'narrative').length > 0 && (
                                        <div>
                                            <div className='result-sec-flex'>
                                                <div>
                                                    <h6 className='see-more-content-store'>Narratives ({sortedResults.filter(item => item.type === 'narrative').length})</h6>
                                                    <div className="line"></div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                {sortedResults?.filter(item => item.type === 'narrative').map((item, index) => (
                                                    <div className="col-md-4 mb-3" key={index}>
                                                        <div className="home-card">
                                                            <div className='card-image-sec' style={{ backgroundImage: `linear-gradient(to bottom, transparent, #052140), url(${normalizeMediaUrl(item.thumbnail, 'background')})` }}>
                                                                <h6 className='card-titile-catlague'>{item.title}</h6>
                                                            </div>
                                                            <div className="contained">
                                                                <p className='card-p-cata'>
                                                                    {item.shortDescription}
                                                                </p>
                                                                <div className="card-btn-sec-new">
                                                                    <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(item.id, item.type)}`}>
                                                                        <button className='card-cat-btn1'>View Details</button>
                                                                    </Link>

                                                                    {item.playbook ? (
                                                                        <button className='card-cat-btn2' onClick={() => handlePlaybookClick(item.playbook)}>
                                                                            Playbook <i className="fa-solid fa-book"></i>
                                                                        </button>
                                                                    ) : (

                                                                        <></>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Content */}
                                    {sortedResults?.filter(item => item.type === 'content').length > 0 && (
                                        <div>
                                            <div className='result-sec-flex'>
                                                <div>
                                                    <h6 className='see-more-content-store'>Content ({sortedResults.filter(item => item.type === 'content').length})</h6>
                                                    <div className="line"></div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                {sortedResults.filter(item => item.type === 'content').map((item, index) => (
                                                    <div className="col-sm-3" key={index}>

                                                        {item.contentType === 'Presentation' && (
                                                            <div className="bg-primary-ppt" style={{ backgroundImage: `linear-gradient(to bottom, transparent, #052140), url(${normalizeMediaUrl(item.thumbnail, 'background')})` }} onClick={() => handleShowFileModal(item)}>{item.fileName}</div>
                                                        )}
                                                        {item.contentType === 'Video' && (
                                                            <div className="bg-primary-video" style={{ backgroundImage: `linear-gradient(to bottom, transparent, #052140), url(${normalizeMediaUrl(item.thumbnail, 'background')})` }} onClick={() => handleShowFileModal(item)}>{item.fileName}</div>
                                                        )}
                                                        {item.contentType === 'Shorts' && (
                                                            <div className="bg-primary-video" style={{ backgroundImage: `linear-gradient(to bottom, transparent, #052140), url(${normalizeMediaUrl(item.thumbnail, 'background')})` }} onClick={() => handleShowFileModal(item)}>{item.fileName}</div>
                                                        )}
                                                        {item.contentType === 'Playbook' && (
                                                            <div className="bg-primary-playbook" style={{ backgroundImage: `linear-gradient(to bottom, transparent, #052140), url(${normalizeMediaUrl(item.thumbnail, 'background')})` }} onClick={() => handleShowFileModal(item)}>{item.fileName}</div>
                                                        )}

                                                        {item.contentType === 'Release Note' && (
                                                            <div
                                                                className="bg-primary-release"
                                                                style={getContentStoreCardBackgroundStyle(item.thumbnail)}
                                                                onClick={() => handleShowFileModal(item)}
                                                            >
                                                                <div className="file-info">
                                                                    <p className='relase-notes-title'>{item.fileName}</p>
                                                                    <p className='file-date'>Date : {formatReleaseDate(item.releaseDate)}</p>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* <div className="bg-primary-ppt" style={{ backgroundImage: `linear-gradient(to bottom, rgba(5, 33, 64, 0), rgba(0, 0, 0, 0.5)), url(${item.thumbnail})` }}>
                                                    {item.fileName}
                                                </div> */}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}





                                    <br></br>
                                    {/* Microcerts */}
                                    {sortedResults?.filter(item => item.type === 'microcert').length > 0 && (
                                        <div>
                                            <div className='result-sec-flex'>
                                                <div>
                                                    <h6 className='see-more-content-store'>Microcerts ({sortedResults.filter(item => item.type === 'microcert').length})</h6>
                                                    <div className="line"></div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                {sortedResults.filter(item => item.type === 'microcert').map((item, index) => (
                                                    <div className='col-sm-6 col-md-4 col-lg-3' key={index}>
                                                        <div className='sub-course-card'>
                                                            <div className='course-image-micro'>
                                                                <img src={normalizeMediaUrl(item.thumbnail, 'image')} alt='Course Showcase' />
                                                            </div>
                                                            <div className='sub-course-details'>
                                                                <h2 className='sub-course-name'>{item.title}</h2>
                                                                <div className='cour-dist'>
                                                                    <p className='sub-course-dist-det'>
                                                                        <span className='sub-cougrse-dist-det-one'>&#8226; {item.completionTime}</span>
                                                                    </p>
                                                                </div>
                                                                <p className='sub-course-det-paragraph'>{item.shortDescription}</p>
                                                                {item.trackTitle ? (
                                                                    <Link to={`${PATH.LEARNING_HUB_MICROCERTS_PATH}${item.trackTitle}/${encryptId(item.id, item.type)}`}>
                                                                        <p className='launch-button'>Launch now {'>>'}</p>
                                                                    </Link>
                                                                ) : (
                                                                    <Link to={`${PATH.LEARNING_HUB_MANDATORY_TRAINING_PATH}${encryptId(item.id, item.type)}`}>
                                                                        <p className='launch-button'>Launch now {'>>'}</p>
                                                                    </Link>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}





                                    {/* FAQs */}
                                    {sortedResults?.filter(item => item.type === 'faq').length > 0 && (
                                        <div>
                                            <div className='result-sec-flex'>
                                                <div>
                                                    <h6 className='see-more-content-store'>FAQs ({sortedResults.filter(item => item.type === 'faq').length})</h6>
                                                    <div className="line"></div>
                                                </div>
                                            </div>

                                            <div>
                                                {sortedResults.filter(item => item.type === 'faq').map((item, index) => (
                                                    <div key={index}>
                                                        <center>
                                                            <label htmlFor={`check${item.id}`} className="togButton-faq" onClick={() => handleToggle(index)}>
                                                                <div className='question-align'>
                                                                    <h1 className='question-text' dangerouslySetInnerHTML={{ __html: item?.question }}></h1>
                                                                    <div className='down-arraow'>
                                                                        {expandedIndex === index ? <i className="fa-solid fa-chevron-up"></i> : <i className="fa-solid fa-chevron-down"></i>}
                                                                    </div>
                                                                </div>
                                                            </label>
                                                        </center>
                                                        <center>
                                                            <input type="checkbox" className="togCheck" id={`check${item.id}`} checked={expandedIndex === index} />
                                                            <div className="togContent-faq" style={{ maxHeight: expandedIndex === index ? '1000px' : '0', opacity: expandedIndex === index ? 1 : 0, visibility: expandedIndex === index ? 'visible' : 'hidden' }}>
                                                                <div>
                                                                    <p className='answer-tag'>Answer</p>
                                                                    <div className='txt' dangerouslySetInnerHTML={{ __html: item?.answer }} />
                                                                    {/* <p className='answer-tag-paragra'>{faq.answer}</p> */}
                                                                </div>
                                                            </div>
                                                        </center>
                                                    </div>
                                                ))}







                                            </div>


                                        </div>
                                    )}


                                    <br></br>


                                    {/* Paths  */}
                                    {sortedResults?.filter(item => item.type === 'url').length > 0 && (
                                        <div>
                                            <div className='result-sec-flex'>
                                                <div>
                                                    <h6 className='see-more-content-store'>URLs ({sortedResults.filter(item => item.type === 'url').length})</h6>
                                                    <div className="line"></div>
                                                </div>
                                            </div>

                                            <div className="container">
                                                <div className="row">
                                                    {sortedResults.filter(item => item.type === 'url').map((item, index) => (
                                                        <div key={index} className="col-sm-6 col-md-4 col-lg-3">
                                                            <div className="path-card">
                                                                <h4 className='path-name'>{item.name.charAt(0).toUpperCase() + item.name.slice(1)} Page</h4>
                                                                <a href={`${item.url}`} className="path-link">Go to {item.name.charAt(0).toUpperCase() + item.name.slice(1)}</a>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>



                                        </div>
                                    )}





                                </>
                            ) : (
                                <div className="no-results-message">
                                    <p>No results found. Please try a different search.</p>
                                </div>
                            )}
                        </>
                    )}


                </div>



                {/* Content Showing Model */}
                <Modal
                    {...props}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    show={showFileModal} fullscreen={true} >
                    <Modal.Body className='content-store-popup'>
                        <div className="container">
                            <div className='modal-div-learning'>
                                <div className="row">
                                    <div className="col-sm-8 mb-3 mb-sm-0">
                                        {selectedFile && (
                                            <>
                                                {isVideoContent(selectedFile) ? (
                                                    getMediaProvider(selectedFile.viewUrl) === 'google-drive' ? (
                                                        <div className="file-container">
                                                            <iframe
                                                                src={normalizeMediaUrl(selectedFile.viewUrl, 'preview')}
                                                                frameborder="0"
                                                                width="100%"
                                                                height="100%"
                                                                allowfullscreen="true"
                                                                title="File Preview"
                                                            ></iframe>
                                                        </div>
                                                    ) : (

                                                        <div className="video-wrapper" onContextMenu={handleContextMenu}>
                                                            <ReactPlayer
                                                                url={selectedFile.viewUrl}
                                                                controls
                                                                playing={playing}
                                                                width="100%"
                                                                height="400px"
                                                                light={normalizeMediaUrl(selectedFile?.thumbnail, 'thumbnail')}
                                                                playIcon={
                                                                    <button className="custom-play-button" onClick={handlePlayButtonClick}>
                                                                        ▶️
                                                                    </button>
                                                                }
                                                            />
                                                        </div>
                                                    )
                                                ) : (
                                                    <div className="file-container">
                                                        <iframe
                                                            src={normalizeMediaUrl(selectedFile.viewUrl, 'preview')}
                                                            frameborder="0"
                                                            width="100%"
                                                            height="100%"
                                                            allowfullscreen="true"
                                                            title="File Preview"
                                                        ></iframe>
                                                    </div>
                                                )}
                                                {isVideoContent(selectedFile) && (
                                                    <p className="video-download-hint">Download is available from the video player controls.</p>
                                                )}
                                            </>
                                        )}

                                    </div>
                                    <div className="col-sm-4 mb-3 mb-sm-0">
                                        <div className="file-controls-dive">
                                            <h1 className='file-tite-des'>{selectedFile && selectedFile.fileName}</h1>
                                            <div class="line"></div>
                                            {/* <p className='file-p-des'>Publish Date : {selectedFile && selectedFile.releaseDate}</p> */}
                                            {/* <button class="card-cat-download" onClick={() => downloadFile(selectedFile)}disabled={downloading}>{downloading ? 'Downloading...' : 'Download'}</button> */}
                                            {/* <button
                                            className="card-cat-download"
                                            onClick={() => downloadFile(selectedFile)}
                                            disabled={downloading}
                                        >
                                            {downloading ? 'Downloading...' : 'Download PPT'}
                                        </button>
                                        <br></br>
                                        <br></br> */}
                                            {selectedFile && selectedFile.contentType == 'Playbook' && (
                                                <p className='file-p-des'>Password :
                                                    <span
                                                        onClick={() => copyToClipboard('Playbook@123')}
                                                        style={{ cursor: 'pointer', }}
                                                        className='passowrd'
                                                    >
                                                        Copy Password
                                                    </span>
                                                </p>
                                            )}
                                            {selectedFile && !isVideoContent(selectedFile) && (
                                                <>
                                                    <button
                                                        className="card-cat-download"
                                                        onClick={() => downloadFile(selectedFile)}
                                                        disabled={downloading}
                                                    >
                                                        {downloading ? 'Downloading...' : 'Download'}
                                                    </button>
                                                    <br />
                                                    <br />
                                                </>
                                            )}
                                            <button className='card-cat-cancel' onClick={handleCloseFileModal}>Back</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>




                {/*Playbook - Modal for selecting playbooks if there are multiple */}
                <Modal show={isModalOpen} onHide={closeModal} centered>
                    <Modal.Body>
                        <button className="close-button-black" onClick={() => closeModal()}><span aria-hidden="true">&times;</span></button><br></br>
                        <div class="row">
                            {selectedPlaybooks.map((playbook, index) => (
                                <div class="col" key={index}>
                                    <div className="bg-primary-playbook-demo-catal" onClick={() => handlePlaybookSelection(playbook)}>
                                        {playbook.title}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Modal.Body>
                </Modal>



                {/*Playbook - Modal for displaying selected playbook */}
                <Modal
                    {...props}
                    size="xl"
                    show={isPlaybookModalOpen}
                    onHide={closePlaybookModal}
                    centered>

                    <Modal.Body className='content-store-popup'>
                        <div className="container">
                            <div className='modal-div-learning'>
                                <div className="row">
                                    <div className="col-sm-8 mb-3 mb-sm-0">
                                        {selectedPlaybook && (
                                            <div className="file-container">
                                                <iframe src={normalizeMediaUrl(selectedPlaybook.viewUrl, 'preview')} frameborder="0" width="100%" height="100%" allowfullscreen="true" title="File Preview"></iframe>
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-sm-4 mb-3 mb-sm-0">
                                        <div className="file-controls-dive">
                                            <h1 className='file-tite-des'>{selectedPlaybook && selectedPlaybook.title}</h1>
                                            <div class="line"></div>
                                            {/* <p className='file-p-des'>Publish Date : {selectedPlaybook && selectedPlaybook.releaseDate}</p> */}
                                            <p className='file-p-des'>Password :
                                                <span
                                                    onClick={() => copyToClipboard('Playbook@123')}
                                                    style={{ cursor: 'pointer', }}
                                                    className='passowrd'>
                                                    Copy Password
                                                </span>
                                            </p>
                                            <button className='card-cat-cancel' onClick={closePlaybookModal}>Back</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>



            </div>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>

        </>
    );
}

export default Search_Result;
